b<template>
    <div class="heading">
        <div class="heading-row">
            <div class="col-left">
                <div class="subcol-left">
                    <div class="logo">
                        <div class="logo-img"><img src="/icons/ua.png" /></div>
                        <div class="logo-text"><h1 class="logo"><router-link :to="'/'">UtterAccess</router-link></h1></div>
                    </div>
                </div>
                <div class="subcol-right">
                    <ul class="navlinks navlinks-list">
                        <li><router-link v-bind:to="'/'">Home</router-link></li>
                        <li><router-link v-bind:to="'/boards'">Boards</router-link></li>
                        <!--<li><a href="#">Wiki</a></li>-->
                        <li v-if="showAdminLink"><router-link v-bind:to="'/admin'">Admin</router-link></li>
                    </ul>
                </div>
            </div>
            <div class="col-right">
                <div class="subcol-left">
                    <div class="nav-search-container">
                        <div class="search-std">
                            <input type="text" placeholder="Search..." v-model="searchText" id="search-text-input" @keyup.enter="search"/>
                            <div id="search-icon-container"><img src="/icons/icon-search-3.png" alt="search"/></div>
                        </div>
                        <div class="search-adv">
                            <router-link v-bind:to="'/search/topic'" >
                                <img src="/icons/icon-adv-search.png" alt="advanced search"/>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="subcol-right">
                    <div v-if="loggedIn">
                        <div class="nav-profile-container">
                            <!--
                            <div class="column-profile-avatar">
                                <div class="profile-avatar"><router-link :to="{path: '/members/' + currentMemberID}"><img :src="avatarImageSource" alt=""/></router-link></div>
                            </div>
                            -->
                            <div class="column-profile-name">
                                <div class="profile-name">
                                    <h1><router-link :to="{path: '/members/' + currentMemberID}">{{ displayName }}</router-link></h1>
                                    <p><router-link v-if="loggedIn" to="/" v-on:click.native="logout()" replace>Logout</router-link> | <router-link :to="{path: '/members/' + currentMemberID + '/edit'}">My Profile</router-link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="loggedOut">
                        <div class="nav-profile-container">
                            <!--<div class="column-profile-avatar">
                                <div class="profile-avatar"><a href="#"><img :src="avatarImageSource" alt=""/></a></div>
                            </div>-->
                            <div class="column-profile-name">
                                <div class="profile-name">
                                    <h1>UA Guest</h1>
                                    <p><router-link to="/register">Register</router-link> | <router-link to="/login" v-on:click.native="login()" replace>Login</router-link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../api/api";

    export default {
        data() {
            return {
                publicPath: process.env.BASE_URL,
                searchText: null,
            }
        },
        computed: {
            avatarImageSource: function() {
                return '/icons/avatar.png'
            },
            currentMemberID: function() {
                return this.$store.getters.user.id;
            },
            displayName: function() {
                return this.$store.getters.displayName;
            },
            loggedIn: function () {
                return this.$store.getters.isLoggedIn === true;
            },
            loggedOut: function () {
                return this.$store.getters.isLoggedIn !== true;
            },
            showAdminLink: function() {
                return this.$store.getters.user.isModerator();
            },
            memberDisplayNameClass: function () {
                var user = this.$store.getters.user;
                return {
                    memberDisplayGuest: user.isGuest(),
                    memberDisplayMember: user.isMember(),
                    memberDisplayVIP: user.isVIP(),
                    memberDisplayEditor: user.isEditor(),
                    memberDisplayModerator: user.isModerator(),
                    memberDisplayForumAdmin: user.isForumAdmin(),
                    memberDisplayCoreAdmin: user.isCoreAdmin()
                }
            }
        },
        methods: {
            login() {
                this.$router.push('/login');
            },
            logout() {
                this.$store.dispatch('logout');
            },
            search() {
                this.$store.commit('setSearchedTopics', []);
                let requestBody = {
                    startedBy: null,
                    exactMatch: null,
                    startDateType: null,
                    dateAfter: null,
                    dateBefore: null,
                    title: this.searchText,
                    exactMatchTitle: null,
                    postCountType: null,
                    postCount: null,
                    attatchments: null
                }

                if(this.searchText){
                    api.post('/search/advancedTopic', requestBody).then((r) => {
                        this.$store.commit('setSearchedIdTopics', r.data);
                        this.$router.push('/topics/list/search')
                    });
                }
            }
        }
    }
</script>
